import React from 'react';
import ExcelWidgetBuilder from './ExcelWidgetBuilder';
import ExcelWidgetRenderer from './ExcelWidgetRenderer';
import Preview from './Preview';
import type { WidgetDefinition } from '../../../registry';
import type { ExcelWidgetConfig } from './types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';

export { default as ExcelWidgetBuilder } from './ExcelWidgetBuilder';
export { default as ExcelWidgetRenderer } from './ExcelWidgetRenderer';
export * from './types';

export const definition: WidgetDefinition = {
  type: 'onedrive',
  meta: {
    label: 'Excel',
    icon: React.createElement(FontAwesomeIcon, { icon: faFileExcel }),
    description: 'Open and work with Microsoft Excel spreadsheets',
    isSystem: true,
    isCreatable: false,
    editableInWorkflow: true,
    dataFlow: 'both',
  },
  defaultSize: { w: 12, h: 6, minW: 4, minH: 3 },
  defaultConfig: () => ({} as ExcelWidgetConfig),
  Builder: ExcelWidgetBuilder,
  Renderer: ExcelWidgetRenderer,
  Preview,
};
